import { createContext, useContext, useState, type ReactNode } from "react";

type EnrollmentPollingContextType = {
  isAnyPolling: boolean;
  setPollingState: (isPolling: boolean) => void;
};

const EnrollmentPollingContext = createContext<EnrollmentPollingContextType | undefined>(undefined);

export function EnrollmentPollingProvider({ children }: { children: ReactNode }) {
  const [isAnyPolling, setIsAnyPolling] = useState(false);

  return (
    <EnrollmentPollingContext.Provider value={ { isAnyPolling, setPollingState: setIsAnyPolling } }>
      { children }
    </EnrollmentPollingContext.Provider>
  );
}

export function useEnrollmentPollingContext() {
  const context = useContext(EnrollmentPollingContext);
  if (!context) {
    throw new Error("useEnrollmentPollingContext must be used within EnrollmentPollingProvider");
  }
  return context;
}
